// GOOGLE SCRIPT PATH
export const GOOGLE_SCRIPT_PATH = 'https://accounts.google.com/gsi/client'
